import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Atividade } from 'src/app/core/atividade';
import { Programa } from 'src/app/core/programa';
import { Projeto } from 'src/app/core/projeto';
import { Turmas } from 'src/app/core/turmas';
import { Unidade } from 'src/app/core/unidade';
import { Acesso } from '../../../../core/acesso';
import { CarregarPerfil } from '../../../../core/carregar-perfil';
import { TurmasService } from './../../../../services/turmas/turmas.service';

@Component({
  selector: 'cadastrar-oficinas',
  templateUrl: './cadastrar-oficinas.component.html',
  styleUrls: ['./cadastrar-oficinas.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm },
    { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }
   ]
})
export class CadastrarOficinasComponent implements OnInit {

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;
  
  @Input() turma: Turmas;
  @Input() isValidarFormulario = false;
  @Output() fecharFormulario = new EventEmitter();

  oficina: Atividade = new Atividade();
  isAtualizar = false;
  turmas: Turmas[];

  menu: string;
  area: string;
  constructor(private turmaService: TurmasService, private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.initObjeto();

    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }
    this.area = this.getArea();
    this.turmaService.getAll().subscribe((turmas: Turmas[]) => {
      this.turmas = turmas;
    });
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  atualizarOficina(oficina: Atividade) {
    this.isAtualizar = true;
    this.oficina = oficina;
  }


  initObjeto() {
    this.oficina = new Atividade();
    this.oficina.projeto = new Projeto();
    this.oficina.programa = new Programa();
    this.oficina.unidade = new Unidade();
  }


  adicionar() {
      if (!this.oficina.colaboradoresAtividade) {
        this.oficina.colaboradoresAtividade = [];
      }
      if (!this.oficina.materiaisAtividade) {
        this.oficina.materiaisAtividade = [];
      }

      const oficina = new Atividade();
      oficina.area = this.area;
      Object.assign(oficina, this.oficina);

      this.turma.oficinas.push(oficina);
      this.initObjeto();

      this.fecharFormulario.emit(true);
  }

  atualizar() {
    const index = this.turma.oficinas.indexOf(this.turma.oficinas.find(col => col.id === this.oficina.id));
    this.turma.oficinas.splice(index, 1, this.oficina);
    this.isAtualizar = false;
    this.initObjeto();
    this.fecharFormulario.emit(true);
  }

  cancelar() {
    this.initObjeto();
    this.isAtualizar = false;
  }

}
